(function(angular, _) {
    angular.module('um.commonFilters')

        /**
         * @ngdoc filter
         * @name numberFormatMask
         * @description Returns a mask string for the provided number format object that should have the signature {numberFormatGrouping, numberFormatSeparator}
         */
        .filter('numberFormatMask', [function() {
            return function(numberFormat) {
                if (!numberFormat) {
                    return '';
                }

                const grouping = numberFormat.numberFormatGrouping;
                const separator = numberFormat.numberFormatSeparator;

                return `1${grouping}234${grouping}567${separator}89`;
            }
        }]);
})(window.angular, window._);
